import React from 'react';
import Select from 'react-select';
import { Button, Modal, Radio } from 'semantic-ui-react';
import debounce from '../../../../utils/debounce';
import {
  ReplaceButtonBlock,
  SearchDishBlock,
  SearchDishBlockLabel,
  RecommendedDishBlock,
  RecommendedDishTitle,
  RecommendedDishText,
  DishOptionsBlock,
} from './AddDishModalStyles';
import { defualt_portion, breakfastTags, dinnerTags } from '../../youslim2.0_Constants';

const AddDishModal = ({
  isOpen,
  addDishPositionType = 'Перекурс',
  onClose,
  onPressAddDish,
  getDishListByName,
  dishes,
}) => {
  const [dishList, setDishList] = React.useState([0]);
  const [choosedDishPosition, setChoosedDishPosition] = React.useState(0);
  const [choosedDishPortion, setChoosedDishPortion] = React.useState(0);
  const [dropdownDish, setDropdownDish] = React.useState('');
  const [positionTypeList, setPositionTypeList] = React.useState([]);

  const onChangeDish = (dish) => {
    setDropdownDish(dish);
  };

  const onSearchProduct = (value) => {
    getDishListByName(value);
  };

  React.useEffect(() => {
    const newDishes = [];
    dishes.forEach((dish) => {
      newDishes.push({ label: dish.title, value: dish.title, id: dish.id });
    });

    setDishList(newDishes);
  }, [dishes]);

  React.useEffect(() => {
    if (addDishPositionType === 'Завтрак') {
      setPositionTypeList(breakfastTags);
    } else if (addDishPositionType === 'Обед' || addDishPositionType === 'Ужин') {
      setPositionTypeList(dinnerTags);
    } else setPositionTypeList([]);

    getDishListByName();
    setDropdownDish('');
    setChoosedDishPosition(0);
    setChoosedDishPortion(0);
  }, [isOpen]);

  const onAddDish = React.useCallback(() => {
    if (choosedDishPosition === 0) {
      onPressAddDish(choosedDishPortion, choosedDishPortion, dropdownDish.id);
    } else onPressAddDish(choosedDishPortion, choosedDishPosition, dropdownDish.id);
  }, [choosedDishPortion, choosedDishPortion, dropdownDish]);

  return (
    <Modal
      style={{ alignSelf: 'center' }}
      open={isOpen}
      centered
      size="medium"
      closeIcon
      onClose={onClose}
    >
      <Modal.Header style={{ textAlign: 'center' }}>
        <p>Добавление блюда</p>
      </Modal.Header>

      <Modal.Content>
        <SearchDishBlock>
          <SearchDishBlockLabel>Поиск блюда</SearchDishBlockLabel>
          <Select
            placeholder="Выберите продукт"
            fluid
            search
            selection
            clearable
            options={dishList}
            value={dropdownDish}
            onInputChange={debounce(onSearchProduct, 1000)}
            onChange={onChangeDish}
          />
        </SearchDishBlock>
        <DishOptionsBlock>
          {!!positionTypeList.length && (
            <div>
              <RecommendedDishTitle>Выберите позицию для блюда</RecommendedDishTitle>
              {positionTypeList.map((position) => (
                <RecommendedDishBlock key={position.id}>
                  <Radio
                    name="radioGroup"
                    value={position.id}
                    checked={choosedDishPosition === position.id}
                    onChange={() => setChoosedDishPosition(position.id)}
                  />

                  <RecommendedDishText>{position.name}</RecommendedDishText>
                </RecommendedDishBlock>
              ))}
            </div>
          )}
          <div>
            <RecommendedDishTitle>Выберите размер порции</RecommendedDishTitle>
            {defualt_portion.map((portion) => (
              <RecommendedDishBlock key={portion.key}>
                <Radio
                  name="radioGroupPortion"
                  value={portion.key}
                  checked={choosedDishPortion === portion.key}
                  onChange={() => setChoosedDishPortion(portion.key)}
                />

                <RecommendedDishText>{portion.ru_value}</RecommendedDishText>
              </RecommendedDishBlock>
            ))}
          </div>
        </DishOptionsBlock>
        <ReplaceButtonBlock>
          <Button
            disabled={
              choosedDishPortion === 0 ||
              (choosedDishPosition === 0 && !!positionTypeList.lenght) ||
              !dropdownDish.id
            }
            color="green"
            onClick={() => onAddDish(choosedDishPortion, choosedDishPosition, dropdownDish.id)}
          >
            Добавить блюдо
          </Button>
          <Button onClick={onClose}>Отмена</Button>
        </ReplaceButtonBlock>
      </Modal.Content>
    </Modal>
  );
};

export default AddDishModal;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/NutritionCourse/AddDishModal/index.jsx